 
import PropertyBreadcrumb from "../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../commonComponents/SortBy";
import GridView from "../../commonComponents/gridView";

const PropertyRightDrawerContainer = () => {
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <GridView type="property" side="no" gridSize={3} carShow={9} />
    </>
  );
};

export default PropertyRightDrawerContainer;
